(function () {
  var SOFT_BUSY_MESSAGE =
    "We're a bit overwhelmed right now. Please try again later.";
  var BUSY_WAIT_MESSAGE = 'A lot of bundle requests, give us an extra minute.';
  var BUSY_RETRY_MS = 60000;

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function getOwnedProductsData() {
    var el = document.getElementById('ovani-owned-products');
    if (!el) return { ids: [], titles: [] };

    try {
      var data = JSON.parse(el.textContent || '{}');
      var ids = (Array.isArray(data.ids) ? data.ids : [])
        .map(function (id) {
          return String(id).trim();
        })
        .filter(Boolean);
      var titles = (Array.isArray(data.titles) ? data.titles : [])
        .map(function (title) {
          return String(title || '').trim();
        })
        .filter(Boolean);
      return { ids: ids, titles: titles };
    } catch {
      return { ids: [], titles: [] };
    }
  }

  function getOwnedProductsList() {
    return getOwnedProductsData().titles;
  }

  function normalizeOwnedTitle(title) {
    return String(title || '')
      .replace(/:/g, '')
      .replace(/\bVol\. 1\b/gi, '')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function buildOwnedMatcher(ownedList, ownedIds) {
    var raw = new Set();
    var normalized = new Set();
    var ids = new Set(
      (Array.isArray(ownedIds) ? ownedIds : []).map(String).filter(Boolean)
    );

    ownedList.forEach(function (item) {
      var value = String(item || '').trim();
      if (!value) return;
      raw.add(value);
      normalized.add(normalizeOwnedTitle(value));
    });

    return function isOwned(product) {
      if (!product) return false;

      var productId = product.id != null ? String(product.id).trim() : '';
      if (productId && ids.has(productId)) return true;

      if (!raw.size && !normalized.size) return false;

      var title = String(product.title || '').trim();
      if (title) {
        if (raw.has(title)) return true;
        if (normalized.has(normalizeOwnedTitle(title))) return true;
      }

      var filename = String(product.filename || '').trim();
      if (filename && raw.has(filename)) return true;

      var samples = Array.isArray(product.filename_sample) ? product.filename_sample : [];
      for (var i = 0; i < samples.length; i++) {
        var sample = String(samples[i] || '').trim();
        if (sample && raw.has(sample)) return true;
      }

      return false;
    };
  }

  function filterOutOwnedProducts(products) {
    var owned = getOwnedProductsData();
    if ((!owned.titles.length && !owned.ids.length) || !Array.isArray(products)) {
      return products;
    }
    var isOwned = buildOwnedMatcher(owned.titles, owned.ids);
    return products.filter(function (product) {
      return !isOwned(product);
    });
  }

  function ownedTitlesForApi() {
    return getOwnedProductsList();
  }

  function waitForOwnershipSync() {
    // Ownership is embedded from Shopify orders on page load — no Fileflare sync wait.
    return Promise.resolve();
  }

  function money(amount, currency) {
    const value = Number(amount);
    if (Number.isNaN(value)) return amount;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(value);
    } catch {
      return `$${value.toFixed(2)}`;
    }
  }

  function setStatus(el, message, tone) {
    if (!el) return;
    el.textContent = message || '';
    if (tone) el.setAttribute('data-tone', tone);
    else el.removeAttribute('data-tone');
  }

  function trackKlaviyoEvent(eventName, properties, customerEmail) {
    try {
      var email = String(customerEmail || '').trim();
      var payload = properties || {};
      var name = String(eventName || '');
      if (!name) return;

      function send() {
        var k = window.klaviyo;
        if (!k) return false;
        try {
          if (email) {
            if (typeof k.identify === 'function') k.identify({ email: email });
            else if (typeof k.push === 'function') k.push(['identify', { email: email }]);
          }
          if (typeof k.track === 'function') k.track(name, payload);
          else if (typeof k.push === 'function') k.push(['track', name, payload]);
          else return false;
          return true;
        } catch (err) {
          return false;
        }
      }

      if (send()) return;

      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (send() || tries >= 40) clearInterval(timer);
      }, 250);
    } catch (err) {
      /* never break the shopper flow */
    }
  }

  /** Prefer Worker soft-busy copy on 429; never mention quotas or AI. */
  function errorFromWorkerResponse(response, data, fallback) {
    if (response && response.status === 429) {
      var msg = data && data.error ? String(data.error).trim() : '';
      return msg || SOFT_BUSY_MESSAGE;
    }
    if (data && data.error) return String(data.error);
    return fallback || 'Something went wrong. Please try again.';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hasPreview(product) {
    return Boolean((product.soundcloud_iframe || '').trim() || (product.youtube_url || '').trim());
  }

  function getColumnCount() {
    if (window.matchMedia('(min-width: 1100px)').matches) return 4;
    if (window.matchMedia('(min-width: 750px)').matches) return 2;
    return 1;
  }

  function isMobilePreview() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function scrollPreviewIntoView(element) {
    if (!element || isMobilePreview()) return;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
    requestAnimationFrame(() => {
      element.scrollIntoView({ behavior, block: 'center' });
    });
  }

  function scrollResultsIntoView(results, grid) {
    if (!results) return;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';

    requestAnimationFrame(() => {
      if (!isMobilePreview()) {
        results.scrollIntoView({ behavior, block: 'start' });
        return;
      }

      const firstCard = grid && grid.querySelector('.ovani-bb__card');
      if (!firstCard) {
        results.scrollIntoView({ behavior, block: 'start' });
        return;
      }

      const peek = 80;
      const cardTop = firstCard.getBoundingClientRect().top + window.scrollY;
      const target = cardTop - window.innerHeight + peek;
      window.scrollTo({ top: Math.max(0, target), behavior });
    });
  }

  function youtubeIframeHtml(url) {
    const src = String(url || '').trim();
    if (!src) return '';
    return (
      `<iframe src="${escapeHtml(src)}" title="YouTube preview" loading="lazy" ` +
      'frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ' +
      'allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>'
    );
  }

  function previewMediaHtml(product) {
    // Single player slot keeps expand panels a consistent height.
    if ((product.soundcloud_iframe || '').trim()) {
      return (
        `<div class="ovani-bb__preview-player ovani-bb__preview-player--soundcloud">${product.soundcloud_iframe}</div>`
      );
    }
    if ((product.youtube_url || '').trim()) {
      return (
        `<div class="ovani-bb__preview-player ovani-bb__preview-player--youtube">${youtubeIframeHtml(product.youtube_url)}</div>`
      );
    }
    return '';
  }

  function productPageUrl(product) {
    return product.url || `/products/${product.handle || ''}`;
  }

  // Labels that already end with a noun — don't append " sounds".
  const CATEGORY_NOUN_RE = /\b(tracks?|loops?|samples?|sounds?|files?|songs?|oneshots?|one[\s-]?shots?)\s*$/i;

  function effectiveTotalSounds(product) {
    const total = Number(product && product.total_sounds);
    if (Number.isFinite(total) && total > 0) return total;
    const counts = Array.isArray(product && product.category_counts)
      ? product.category_counts
      : [];
    let sum = 0;
    let any = false;
    for (const item of counts) {
      const count = Number(item && item.count);
      if (!Number.isFinite(count) || count <= 0) continue;
      sum += count;
      any = true;
    }
    return any ? sum : null;
  }

  function bundleSoundTotal(products) {
    let total = 0;
    let hasSounds = false;

    (Array.isArray(products) ? products : []).forEach((product) => {
      const count = effectiveTotalSounds(product);
      if (!Number.isFinite(count) || count <= 0) return;
      total += count;
      hasSounds = true;
    });

    return hasSounds ? total.toLocaleString() : null;
  }

  function formatCategoryLabel(raw) {
    const label = String(raw || '').trim().toLowerCase();
    if (!label) return '';
    if (CATEGORY_NOUN_RE.test(label)) return label;
    return `${label} sounds`;
  }

  function contentsStatsHtml(product) {
    const category = String(product.category || '').toLowerCase();
    const reason = escapeHtml(product.reason || '');
    const trackCount = Number(product.track_count);
    const totalSounds = effectiveTotalSounds(product);
    const counts = Array.isArray(product.category_counts) ? product.category_counts : [];
    const soundCategories = Array.isArray(product.sound_categories)
      ? product.sound_categories
      : [];

    if (category === 'music') {
      const songs = Number.isFinite(trackCount) && trackCount > 0 ? trackCount : 10;
      const files = Number.isFinite(totalSounds) && totalSounds > 0 ? totalSounds : 50;
      const intro = `<p class="ovani-bb__dropdown-stats"><strong>${songs} songs</strong> that fit well for your game.</p>`;
      const includes =
        `<p class="ovani-bb__dropdown-reason">Every song includes three intensity levels (about 90 seconds each) plus 30- and 60-second rough cuts — five ready-to-use variants per track. Across <strong>${songs}</strong> songs, that's <strong>${files}</strong> music files in this pack. Delivered in 48kHz/24-bit.</p>`;
      return intro + (reason ? `<p class="ovani-bb__dropdown-reason">${reason}</p>` : '') + includes;
    }

    // Voice packs: total → match reason → category names (no counts)
    if (category === 'voice') {
      let html = '';
      if (Number.isFinite(totalSounds) && totalSounds > 0) {
        html += `<p class="ovani-bb__dropdown-stats"><strong>${totalSounds} sounds</strong> in this pack</p>`;
      }
      if (reason) {
        html += `<p class="ovani-bb__dropdown-reason">${reason}</p>`;
      }
      if (soundCategories.length) {
        const items = soundCategories
          .map((label) => {
            const text = escapeHtml(String(label || '').trim());
            return text ? `<li>${text}</li>` : '';
          })
          .filter(Boolean)
          .join('');
        if (items) {
          html += `<ul class="ovani-bb__dropdown-categories">${items}</ul>`;
        }
      }
      return html;
    }

    let html = '';
    if (Number.isFinite(totalSounds) && totalSounds > 0) {
      html += `<p class="ovani-bb__dropdown-stats"><strong>${totalSounds} sounds</strong> in this pack</p>`;
    }
    if (counts.length) {
      const items = counts
        .map((item) => {
          const count = Number(item && item.count);
          const label = escapeHtml(formatCategoryLabel((item && item.label) || ''));
          if (!Number.isFinite(count) || count <= 0 || !label) return '';
          return `<li><strong>${count}</strong> ${label}</li>`;
        })
        .filter(Boolean)
        .join('');
      if (items) {
        html += `<ul class="ovani-bb__dropdown-categories">${items}</ul>`;
      }
    }
    if (reason) {
      html += `<p class="ovani-bb__dropdown-reason">${reason}</p>`;
    }
    return html;
  }

  function buildCard(product, index) {
    const card = document.createElement('article');
    card.className = 'ovani-bb__card';
    card.style.animationDelay = `${index * 0.06}s`;
    card.dataset.handle = product.handle || '';

    const expandable = hasPreview(product);
    if (expandable) {
      card.classList.add('ovani-bb__card--expandable');
      card.tabIndex = 0;
      card.setAttribute('role', 'button');
      card.setAttribute('aria-expanded', 'false');
      card.setAttribute(
        'aria-label',
        `Preview ${product.title || product.handle || 'pack'}`
      );
    }

    const media = document.createElement('div');
    media.className = 'ovani-bb__media';
    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (expandable) {
      const cue = document.createElement('span');
      cue.className = 'ovani-bb__preview-cue';
      cue.textContent = 'Preview';
      cue.setAttribute('aria-hidden', 'true');
      media.appendChild(cue);
    }
    card.appendChild(media);

    const body = document.createElement('div');
    body.className = 'ovani-bb__card-body';

    const title = document.createElement('h3');
    title.className = 'ovani-bb__card-title';
    title.textContent = product.title || product.handle;

    const price = document.createElement('p');
    price.className = 'ovani-bb__price';
    price.textContent = money(product.price, product.currency);

    const reason = document.createElement('p');
    reason.className = 'ovani-bb__reason';
    reason.textContent = product.reason || '';

    body.appendChild(title);
    body.appendChild(price);
    body.appendChild(reason);

    const actions = document.createElement('div');
    actions.className = 'ovani-bb__card-actions';
    const swapBtn = document.createElement('button');
    swapBtn.type = 'button';
    swapBtn.className = 'ovani-bb__swap-btn';
    swapBtn.setAttribute('data-ovani-bb-swap', '');
    swapBtn.textContent = 'Swap';
    swapBtn.setAttribute(
      'aria-label',
      `Swap ${product.title || product.handle || 'pack'}`
    );
    actions.appendChild(swapBtn);
    body.appendChild(actions);

    card.appendChild(body);

    card._ovaniProduct = product;
    return card;
  }

  const BASE_DISCOUNT_BY_SIZE = {
    3: 25,
    6: 35,
    10: 45,
  };
  const PROMO_DISCOUNT_BY_SIZE = {
    3: 50,
    6: 55,
    10: 60,
    20: 65,
  };
  // DEFOLD GAME JAM 2026 — exclusive tiers. Same 3/6/10 pack counts as public.
  // After the jam: delete this map, isDefoldJamProfile(), and data-discount-profile wiring.
  const DEFOLD_DISCOUNT_PROFILE = 'defold-game-jam';
  const DEFOLD_DISCOUNT_BY_SIZE = {
    3: 35,
    6: 45,
    10: 55,
  };
  const BASE_FOOTNOTE =
    'Your personal code (named after your game) gives 25% off a 3-pack, 35% off a 6-pack, or 45% off a 10-pack. Click a pack to preview SoundCloud or YouTube. Use Swap to replace any pack — your code stays the same. Then add to cart — the code applies automatically.';
  const PROMO_FOOTNOTES = {
    sale:
      'Black Friday Sale, through Dec 11: your personal code gives 50% off a 3-pack, 55% off a 6-pack, or 60% off a 10-pack. Click a pack to preview SoundCloud or YouTube. Use Swap to replace any pack — your code stays the same. Then add to cart — the code applies automatically.',
    sale20:
      'Black Friday Sale, through Dec 11: your personal code gives 50% off a 3-pack, 55% off a 6-pack, 60% off a 10-pack, or 65% off a 20-pack. Click a pack to preview SoundCloud or YouTube. Use Swap to replace any pack — your code stays the same. Then add to cart — the code applies automatically.',
    extended:
      'Black Friday Sale extended through Dec 18: your personal code gives 50% off a 3-pack, 55% off a 6-pack, 60% off a 10-pack, or 65% off a 20-pack. Click a pack to preview SoundCloud or YouTube. Use Swap to replace any pack — your code stays the same. Then add to cart — the code applies automatically.',
  };
  const PROMO_BANNERS = {
    sale: 'Black Friday Sale · ends Dec 11',
    sale20: 'Black Friday Sale · ends Dec 11',
    extended: 'Extended! Black Friday Sale · now ends Dec 18',
  };
  const ALL_BUNDLE_SIZES = [3, 6, 10, 20];
  const DRAFT_STORAGE_KEY = 'ovani-bb-saved-bundle';
  const DEFOLD_DRAFT_STORAGE_KEY = 'ovani-bb-saved-bundle-defold';
  const DRAFT_STORAGE_VERSION = 1;

  function isDefoldJamProfile(root) {
    if (String(root && root.dataset && root.dataset.discountProfile).trim() === DEFOLD_DISCOUNT_PROFILE) {
      return true;
    }
    if (root && root.classList && root.classList.contains('ovani-bb--defold')) {
      return true;
    }
    try {
      var path = String(window.location.pathname || '');
      if (path.indexOf('/pages/defold-game-jam-bundle-builder') !== -1) {
        return true;
      }
    } catch (err) {}
    return false;
  }

  function draftStorageKeyForRoot(root) {
    return isDefoldJamProfile(root) ? DEFOLD_DRAFT_STORAGE_KEY : DRAFT_STORAGE_KEY;
  }

  function readSavedBundleDraft(storageKey) {
    try {
      var raw = window.localStorage.getItem(storageKey || DRAFT_STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || data.v !== DRAFT_STORAGE_VERSION) return null;
      if (!data.bundlesBySize || typeof data.bundlesBySize !== 'object') return null;
      if (!String(data.description || '').trim()) return null;
      return data;
    } catch {
      return null;
    }
  }

  function writeSavedBundleDraft(storageKey, data) {
    try {
      window.localStorage.setItem(storageKey || DRAFT_STORAGE_KEY, JSON.stringify(data));
    } catch (err) {}
  }

  function clearSavedBundleDraft(storageKey) {
    try {
      window.localStorage.removeItem(storageKey || DRAFT_STORAGE_KEY);
    } catch (err) {}
  }

  function discountCodesFromBundles(bundles) {
    var codes = [];
    if (!bundles || typeof bundles !== 'object') return codes;
    ALL_BUNDLE_SIZES.forEach(function (size) {
      var entry = bundles[size] || bundles[String(size)];
      var code = entry && entry.discount_code ? String(entry.discount_code).trim() : '';
      if (code) codes.push(code);
    });
    return codes;
  }

  function bundleEntry(bundles, size) {
    if (!bundles) return null;
    return bundles[size] || bundles[String(size)] || null;
  }

  function bundleProductsFullyOwned(bundle) {
    if (!bundle || !Array.isArray(bundle.products) || !bundle.products.length) return false;
    var owned = getOwnedProductsData();
    if (!owned.titles.length && !owned.ids.length) return false;
    var isOwned = buildOwnedMatcher(owned.titles, owned.ids);
    return bundle.products.every(function (product) {
      return isOwned(product);
    });
  }

  function parsePromoMs(value) {
    const ms = Date.parse(String(value || ''));
    return Number.isFinite(ms) ? ms : NaN;
  }

  const PROMO_PHASES = ['regular', 'vip', 'sale', 'sale20', 'extended'];
  const VIP_BANNER = 'VIP Early Access · Black Friday Sale';
  const VIP_CODE_KEY = 'ovani-bb-vip-code';
  const VIP_OK_KEY = 'ovani-bb-vip-ok';

  // VIP early access: ?vip=CODE from the VIP email. The code is remembered so
  // a VIP can come back without the link; the worker decides if it's valid.
  function savedVipCode() {
    try {
      var fromUrl = (new URLSearchParams(window.location.search).get('vip') || '').trim();
      if (fromUrl && fromUrl !== window.localStorage.getItem(VIP_CODE_KEY)) {
        window.localStorage.setItem(VIP_CODE_KEY, fromUrl);
        window.localStorage.removeItem(VIP_OK_KEY);
      }
      return window.localStorage.getItem(VIP_CODE_KEY) || '';
    } catch (err) {
      return '';
    }
  }

  function vipConfirmed() {
    try {
      var code = window.localStorage.getItem(VIP_CODE_KEY) || '';
      return Boolean(code) && window.localStorage.getItem(VIP_OK_KEY) === code;
    } catch (err) {
      return false;
    }
  }

  function rememberVipResult(code, ok) {
    try {
      if (ok) {
        window.localStorage.setItem(VIP_OK_KEY, code);
      } else if (window.localStorage.getItem(VIP_CODE_KEY) === code) {
        window.localStorage.removeItem(VIP_CODE_KEY);
        window.localStorage.removeItem(VIP_OK_KEY);
      }
    } catch (err) {}
  }

  /** True while a confirmed VIP has sale prices the public doesn't have yet. */
  function vipEarlyAccess(root, nowMs) {
    if (isDefoldJamProfile(root) || !vipConfirmed()) return false;
    const preview = previewPhase();
    if (preview) return preview === 'vip';
    const vipStartMs = parsePromoMs(root.dataset.promoVipStart);
    const startMs = parsePromoMs(root.dataset.promoStart);
    if (!Number.isFinite(vipStartMs) || !Number.isFinite(startMs)) return false;
    const now = typeof nowMs === 'number' ? nowMs : Date.now();
    return now >= vipStartMs && now < startMs;
  }

  // ?bb_preview=regular|vip|sale|sale20|extended shows a sale step early. Only honored on
  // preview and development themes, never on the live theme.
  function previewPhase() {
    try {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (!role || role === 'main') return null;
      var phase = new URLSearchParams(window.location.search).get('bb_preview');
      return PROMO_PHASES.indexOf(phase) !== -1 ? phase : null;
    } catch (err) {
      return null;
    }
  }

  /**
   * "regular", "sale" (3/6/10 at sale prices), "sale20" (plus the 20-pack), or
   * "extended" (same prices as sale20, "Extended!" wording).
   */
  function promoPhase(root, nowMs) {
    // Defold Game Jam 2026 uses its own 35/45/55 map — never overlay the public promo.
    if (isDefoldJamProfile(root)) return 'regular';
    const preview = previewPhase();
    if (preview === 'vip') return vipEarlyAccess(root, nowMs) ? 'sale' : 'regular';
    if (preview) return preview;
    if (vipEarlyAccess(root, nowMs)) return 'sale';
    const startMs = parsePromoMs(root.dataset.promoStart);
    const twentyStartMs = parsePromoMs(root.dataset.promoTwentyStart);
    const extendedStartMs = parsePromoMs(root.dataset.promoExtendedStart);
    const endMs = parsePromoMs(root.dataset.promoEnd);
    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 'regular';
    const now = typeof nowMs === 'number' ? nowMs : Date.now();
    if (now < startMs || now >= endMs) return 'regular';
    if (Number.isFinite(extendedStartMs) && now >= extendedStartMs) return 'extended';
    if (Number.isFinite(twentyStartMs) && now >= twentyStartMs) return 'sale20';
    return 'sale';
  }

  /** Moment the worker should price a preview at, matching promoPhase(). */
  function previewAtForPhase(root, phase) {
    if (phase === 'vip') return root.dataset.promoVipStart || null;
    if (phase === 'sale') return root.dataset.promoStart || null;
    if (phase === 'sale20') return root.dataset.promoTwentyStart || null;
    if (phase === 'extended') return root.dataset.promoExtendedStart || null;
    if (phase === 'regular') return root.dataset.promoEnd || null;
    return null;
  }

  function currentBundleSizes(root, nowMs) {
    const phase = promoPhase(root, nowMs);
    return phase === 'sale20' || phase === 'extended' ? [3, 6, 10, 20] : [3, 6, 10];
  }

  function isPromoActive(root, nowMs) {
    return promoPhase(root, nowMs) !== 'regular';
  }

  function discountPercentForSize(root, size) {
    if (isDefoldJamProfile(root)) {
      return DEFOLD_DISCOUNT_BY_SIZE[size] || null;
    }
    if (!currentBundleSizes(root).includes(Number(size))) return null;
    const map = isPromoActive(root) ? PROMO_DISCOUNT_BY_SIZE : BASE_DISCOUNT_BY_SIZE;
    return map[size] || null;
  }

  // Info section text that depends on the sale step. Each slot holds one
  // <template data-phase> per step; the visible copy is the server's guess.
  function applyPhaseSlots(phase) {
    document.querySelectorAll('[data-ovani-bb-phase-slot]').forEach(function (slot) {
      if (slot.getAttribute('data-ovani-bb-phase-slot') !== phase) {
        var template = Array.from(slot.children).find(function (child) {
          return child.tagName === 'TEMPLATE' && child.getAttribute('data-phase') === phase;
        });
        if (!template) return;
        Array.from(slot.childNodes).forEach(function (node) {
          if (node.nodeName !== 'TEMPLATE') slot.removeChild(node);
        });
        slot.insertBefore(template.content.cloneNode(true), slot.firstChild);
        slot.setAttribute('data-ovani-bb-phase-slot', phase);
      }
      slot.hidden = slot.textContent.trim() === '';
    });
  }

  function discountLabelForSize(root, size) {
    const percent = discountPercentForSize(root, size);
    return percent == null ? 'bundle discount' : percent + '% off';
  }

  function bundleSavings(products, percent) {
    if (!Array.isArray(products) || !products.length || !percent) return null;
    let full = 0;
    for (const product of products) {
      const price = Number(product && product.price);
      if (product == null || product.price == null || !Number.isFinite(price)) return null;
      full += price;
    }
    if (full <= 0) return null;
    const saved = Math.round(full * percent) / 100;
    return {
      full: full,
      discounted: full - saved,
      saved: saved,
      currency: (products[0] && products[0].currency) || 'USD',
    };
  }

  function formatCodeNote(discountCode, discountLabel, size, discountCodeError) {
    const label = discountLabel || 'bundle discount';
    if (discountCode) {
      return `${label} · applied automatically at checkout`;
    }
    if (discountCodeError) {
      return `${label} — a personal code could not be created. Rebuild to try again.`;
    }
    return `${label} when you add this ${size}-pack bundle to cart`;
  }

  function discountCodeIsApplied(cart, code) {
    if (!cart || !code) return false;
    const normalized = String(code).trim().toUpperCase();
    if (!normalized) return false;

    const fromApplications = (cart.cart_level_discount_applications || []).some((discount) => {
      return String(discount.title || '').toUpperCase() === normalized;
    });
    if (fromApplications) return true;

    const fromCodes = (cart.discount_codes || []).some((entry) => {
      return String(entry.code || '').toUpperCase() === normalized && entry.applicable !== false;
    });
    if (fromCodes) return true;

    return (cart.items || []).some((item) => {
      const lineTitles = (item.discounts || []).map((discount) => String(discount.title || '').toUpperCase());
      const allocationTitles = (item.line_level_discount_allocations || []).map((allocation) =>
        String((allocation.discount_application && allocation.discount_application.title) || '').toUpperCase()
      );
      return lineTitles.concat(allocationTitles).includes(normalized);
    });
  }

  function cartHasDiscount(cart, code) {
    return discountCodeIsApplied(cart, code) || Number(cart && cart.total_discount) > 0;
  }

  async function fetchCartJson() {
    const cartUrl = ((window.routes && window.routes.cart_url) || '/cart').replace(/\/$/, '') + '.js';
    const response = await fetch(cartUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('cart_fetch_failed');
    return response.json();
  }

  async function applyDiscountCode(code) {
    if (!code) return { applied: false, cart: null };

    try {
      const response = await fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: code }),
      });
      const data = await response.json();
      if (response.ok && !data.status && cartHasDiscount(data, code)) {
        return { applied: true, cart: data };
      }
    } catch {
      // Fall through to /discount/CODE, which sets the checkout cookie.
    }

    try {
      await fetch(`/discount/${encodeURIComponent(code)}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
    } catch {
      // Cookie apply can fail; checkout may still accept the code.
    }

    let cart = null;
    try {
      cart = await fetchCartJson();
    } catch {
      cart = null;
    }
    return {
      applied: cartHasDiscount(cart, code),
      cart,
    };
  }

  async function addBundleToCart(products) {
    const items = products
      .map((p) => ({
        id: Number(p.variant_id),
        quantity: 1,
      }))
      .filter((item) => item.id);

    if (!items.length) {
      throw new Error('No purchasable variants in this bundle.');
    }

    const payload = { items };

    // Preserve affiliate attribution on multi-item Bundle Builder adds.
    try {
      const aff =
        (typeof window.ovaniAffiliateGet === 'function' && window.ovaniAffiliateGet()) ||
        window.ovaniAffiliate ||
        null;
      if (aff && (aff.affiliate_id || aff.code || aff.slug)) {
        payload.attributes = {
          affiliate_id: aff.affiliate_id || '',
          affiliate_code: aff.code || '',
          affiliate_slug: aff.slug || '',
        };
      }
    } catch (_) {}

    const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Could not add bundle to cart.');
    }
    return data;
  }

  function initRoot(root) {
    const workerUrl = (root.dataset.workerUrl || '').replace(/\/$/, '');
    const customerEmail = (root.dataset.customerEmail || '').trim();
    const form = root.querySelector('[data-ovani-bb-form]');
    const textarea = root.querySelector('[data-ovani-bb-description]');
    const submit = root.querySelector('[data-ovani-bb-submit]');
    const status = root.querySelector('[data-ovani-bb-status]');
    const results = root.querySelector('[data-ovani-bb-results]');
    const grid = root.querySelector('[data-ovani-bb-grid]');
    const codeEl = root.querySelector('[data-ovani-bb-code]');
    const codeLabelEl = root.querySelector('[data-ovani-bb-code-label]');
    const codeValueEl = root.querySelector('[data-ovani-bb-code-value]');
    const codeNoteEl = root.querySelector('[data-ovani-bb-code-note]');
    const savingsEl = root.querySelector('[data-ovani-bb-savings]');
    const summaryEl = root.querySelector('[data-ovani-bb-summary]');
    const resultsSubtitleEl = root.querySelector('[data-ovani-bb-results-subtitle]');
    const addBtn = root.querySelector('[data-ovani-bb-add]');
    const sizeButtons = root.querySelectorAll('[data-ovani-bb-size]');
    const sizePicker = root.querySelector('[data-ovani-bb-size-picker]');
    const categoryInputs = root.querySelectorAll('[data-ovani-bb-category]');
    const mobileDropdown = root.querySelector('[data-ovani-bb-mobile-dropdown]');
    const mobileMedia = root.querySelector('[data-ovani-bb-mobile-media]');
    const mobileDetails = root.querySelector('[data-ovani-bb-mobile-details]');
    const mobileClose = root.querySelector('[data-ovani-bb-mobile-close]');
    const swapPanel = root.querySelector('[data-ovani-bb-swap-panel]');
    const swapClose = root.querySelector('[data-ovani-bb-swap-close]');
    const swapReplacing = root.querySelector('[data-ovani-bb-swap-replacing]');
    const leftoversSection = root.querySelector('[data-ovani-bb-swap-leftovers-section]');
    const leftoversList = root.querySelector('[data-ovani-bb-swap-leftovers]');
    const altsStatus = root.querySelector('[data-ovani-bb-swap-alts-status]');
    const altsList = root.querySelector('[data-ovani-bb-swap-alts]');
    const searchInput = root.querySelector('[data-ovani-bb-swap-search]');
    const searchStatus = root.querySelector('[data-ovani-bb-swap-search-status]');
    const searchResults = root.querySelector('[data-ovani-bb-swap-search-results]');

    if (!form || !textarea || !submit || !grid) return;

    const draftStorageKey = draftStorageKeyForRoot(root);
    const discountProfile = isDefoldJamProfile(root)
      ? DEFOLD_DISCOUNT_PROFILE
      : String(root.dataset.discountProfile || '').trim();
    const promoEl = root.querySelector('[data-ovani-bb-promo]');
    const promoTextEl = root.querySelector('[data-ovani-bb-promo-text]');
    const footnoteEl = root.querySelector('[data-ovani-bb-footnote]');
    const baseFootnoteText =
      (footnoteEl && footnoteEl.textContent.trim()) || BASE_FOOTNOTE;

    const params = new URLSearchParams(window.location.search);
    const PREFILL_KEY = 'ovani-bb-prefill';
    const DRAFT_KEY = 'ovani-bb-draft-id';
    const CATEGORIES_KEY = 'ovani-bb-categories';
    let storedPrefill = '';
    let storedDraftId = '';
    let storedCategories = '';
    try {
      storedPrefill = sessionStorage.getItem(PREFILL_KEY) || '';
      storedDraftId = sessionStorage.getItem(DRAFT_KEY) || '';
      storedCategories = sessionStorage.getItem(CATEGORIES_KEY) || '';
      if (storedPrefill) sessionStorage.removeItem(PREFILL_KEY);
      if (storedCategories) sessionStorage.removeItem(CATEGORIES_KEY);
    } catch (err) {
      storedPrefill = '';
      storedDraftId = '';
      storedCategories = '';
    }
    const prefill = storedPrefill || params.get('game') || '';
    if (prefill && textarea) {
      textarea.value = prefill.slice(0, 2000);
    }
    const prefillCategories = String(storedCategories || params.get('categories') || '')
      .split(',')
      .map((item) => item.trim().toLowerCase())
      .filter((item) => item === 'music' || item === 'sfx' || item === 'voice');
    if (prefillCategories.length) {
      const allowed = new Set(prefillCategories);
      categoryInputs.forEach((input) => {
        input.checked = allowed.has(input.value);
      });
    }
    const customAudioDraftId = String(params.get('draft') || storedDraftId || '').trim();
    const incomingNewRequest = Boolean(storedPrefill || params.get('game') || params.get('draft'));

    let selectedSize = 6;
    let bundlesBySize = null;
    let rankedProducts = [];
    let lastDescription = '';
    let lastCategories = [];
    let requestId = null;
    let openCard = null;
    let swapTarget = null;
    let searchTimer = null;
    let searchRequestId = 0;
    let altsRequestId = 0;
    let builtDescription = null;
    let builtCategories = null;
    const defaultSubmitLabel = submit.textContent.trim() || 'BUILD MY BUNDLE';

    const rowDropdown = document.createElement('div');
    rowDropdown.className = 'ovani-bb__row-dropdown';
    rowDropdown.hidden = true;
    rowDropdown.innerHTML =
      '<button type="button" class="ovani-bb__dropdown-close" data-ovani-bb-row-close aria-label="Close preview">' +
      '<span aria-hidden="true">&times;</span></button>' +
      '<div class="ovani-bb__dropdown-content">' +
      '<div class="ovani-bb__dropdown-media" data-ovani-bb-row-media></div>' +
      '<div class="ovani-bb__dropdown-details" data-ovani-bb-row-details></div>' +
      '</div>';
    const rowMedia = rowDropdown.querySelector('[data-ovani-bb-row-media]');
    const rowDetails = rowDropdown.querySelector('[data-ovani-bb-row-details]');
    const rowClose = rowDropdown.querySelector('[data-ovani-bb-row-close]');

    function selectedCategories() {
      return Array.from(categoryInputs)
        .filter((input) => input.checked)
        .map((input) => input.value);
    }

    function categoriesEqual(a, b) {
      if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
      const set = new Set(a);
      return b.every((item) => set.has(item));
    }

    function buildInputsUnchanged() {
      return (
        textarea.value.trim() === builtDescription &&
        categoriesEqual(selectedCategories(), builtCategories)
      );
    }

    function updateRebuildControl() {
      if (builtDescription === null) {
        submit.textContent = defaultSubmitLabel;
        submit.disabled = false;
        return;
      }

      submit.textContent = 'REBUILD MY BUNDLE';
      submit.disabled = buildInputsUnchanged();
    }

    function setSizePressed(size) {
      sizeButtons.forEach((b) => {
        b.setAttribute('aria-pressed', String(Number(b.dataset.ovaniBbSize) === size));
      });
    }

    function renderSizeButtonLabel(btn, size, promo) {
      if (isDefoldJamProfile(root)) {
        const pct = DEFOLD_DISCOUNT_BY_SIZE[size];
        btn.textContent = size + ' packs · Save ' + pct + '%';
        btn.setAttribute('aria-label', size + ' packs, save ' + pct + ' percent');
        return;
      }
      const base = BASE_DISCOUNT_BY_SIZE[size];
      const promoPct = PROMO_DISCOUNT_BY_SIZE[size];
      if (promo && base == null) {
        btn.textContent = size + ' packs · ' + promoPct + '% off';
        btn.setAttribute('aria-label', size + ' packs, ' + promoPct + ' percent off');
        return;
      }
      if (promo) {
        btn.innerHTML =
          size +
          ' packs · <s>' +
          base +
          '%</s> ' +
          promoPct +
          '% off';
        btn.setAttribute(
          'aria-label',
          size + ' packs, ' + promoPct + ' percent off, was ' + base + ' percent off'
        );
      } else {
        btn.textContent = size + ' packs · ' + base + '% off';
        btn.removeAttribute('aria-label');
      }
    }

    function applyPromoUi() {
      const now = Date.now();
      const phase = promoPhase(root, now);
      const active = phase !== 'regular';

      if (promoEl) {
        promoEl.hidden = !active;
        const banner = vipEarlyAccess(root, now) ? VIP_BANNER : PROMO_BANNERS[phase];
        if (promoTextEl && banner) promoTextEl.textContent = banner;
      }

      // A size the worker didn't build (e.g. a voice-only 20-pack) stays hidden.
      const sizes = currentBundleSizes(root, now);
      sizeButtons.forEach((btn) => {
        const size = Number(btn.dataset.ovaniBbSize);
        const offered =
          sizes.includes(size) && (!bundlesBySize || Boolean(bundleEntry(bundlesBySize, size)));
        btn.hidden = !offered;
        if (!offered) return;
        renderSizeButtonLabel(btn, size, active);
      });

      if (footnoteEl) {
        footnoteEl.textContent = PROMO_FOOTNOTES[phase] || baseFootnoteText;
      }

      if (!isDefoldJamProfile(root)) applyPhaseSlots(phase);
    }

    applyPromoUi();

    // Confirm a VIP link with the worker so VIP prices show before the first build.
    const pageVipCode = isDefoldJamProfile(root) ? '' : savedVipCode();
    if (pageVipCode && workerUrl) {
      fetch(`${workerUrl}/vip`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ vip: pageVipCode }),
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((result) => {
          if (!result) return;
          rememberVipResult(pageVipCode, result.vip === true);
          applyPromoUi();
        })
        .catch(() => {});
    }

    // Re-check so a page left open across a sale switch updates without a reload.
    const promoEndMs = parsePromoMs(root.dataset.promoEnd);
    if (!isDefoldJamProfile(root) && Number.isFinite(promoEndMs) && Date.now() < promoEndMs) {
      const promoTimer = window.setInterval(function () {
        applyPromoUi();
        if (Date.now() >= promoEndMs) window.clearInterval(promoTimer);
      }, 30000);
    }

    function setSizeButtonsBusy(busy) {
      sizeButtons.forEach((btn) => {
        if (busy) {
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-busy');
        } else {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-busy');
        }
      });
    }

    function activeBundle() {
      if (!bundlesBySize) return null;
      return bundlesBySize[selectedSize] || null;
    }

    function bundleEventProperties(products, discountCode) {
      var titles = Array.isArray(products)
        ? products
            .map(function (p) {
              return String((p && (p.title || p.handle)) || '').trim();
            })
            .filter(Boolean)
        : [];
      var codes = [];
      if (bundlesBySize) {
        currentBundleSizes(root).forEach(function (size) {
          var entry = bundlesBySize[size];
          var code = entry && entry.discount_code ? String(entry.discount_code).trim() : '';
          if (code) codes.push(code);
        });
      }
      var selectedCode =
        discountCode != null && String(discountCode).trim()
          ? String(discountCode).trim()
          : '';
      return {
        'Bundle Size': selectedSize,
        'Pack Titles': titles,
        'Discount Code': selectedCode,
        'Discount Codes': codes.join('; '),
        'Game Description': lastDescription || '',
        'Categories': Array.isArray(lastCategories) ? lastCategories.join(', ') : '',
        'Request ID': requestId || '',
        'Bundle URL': String(window.location.href || '').split('#')[0],
      };
    }

    function parseBundlesResponse(data) {
      const out = {};
      const raw = data && data.bundles;

      if (raw && typeof raw === 'object') {
        currentBundleSizes(root).forEach((size) => {
          const entry = raw[String(size)] || raw[size];
          if (!entry || !Array.isArray(entry.products)) return;
          out[size] = {
            products: entry.products,
            discount_code: entry.discount_code || null,
            discount_code_error: entry.discount_code_error || null,
            discount_label: entry.discount_label || discountLabelForSize(root, size) || '',
          };
        });
      }

      // Legacy single-size response fallback.
      if (!Object.keys(out).length && Array.isArray(data.products) && data.products.length) {
        const size = currentBundleSizes(root).includes(Number(data.size)) ? Number(data.size) : selectedSize;
        out[size] = {
          products: data.products,
          discount_code: data.discount_code || null,
          discount_code_error: data.discount_code_error || null,
          discount_label: data.discount_label || discountLabelForSize(root, size) || '',
        };
      }

      return Object.keys(out).length ? out : null;
    }

    // A saved bundle keeps the label from when it was built; the code itself
    // follows the sale step, so show today's percent.
    function bundleDiscountLabel(bundle, size) {
      const saved = (bundle && bundle.discount_label) || '';
      if (discountPercentForSize(root, size) == null) return saved;
      const previewNote = /local preview/.test(saved) ? ' · local preview, no real code' : '';
      return discountLabelForSize(root, size) + previewNote;
    }

    function currentBundleHandles() {
      const bundle = activeBundle();
      if (!bundle || !Array.isArray(bundle.products)) return new Set();
      return new Set(bundle.products.map((p) => p.handle).filter(Boolean));
    }

    function leftoverProducts() {
      const inBundle = currentBundleHandles();
      return filterOutOwnedProducts(
        rankedProducts.filter((p) => p.handle && !inBundle.has(p.handle))
      );
    }

    function excludeHandlesForApi() {
      const exclude = currentBundleHandles();
      rankedProducts.forEach((p) => {
        if (p.handle) exclude.add(p.handle);
      });
      return Array.from(exclude);
    }

    function buildSwapOption(product) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ovani-bb__swap-option';
      btn.setAttribute('data-ovani-bb-swap-pick', '');
      btn._ovaniProduct = product;

      const media = document.createElement('div');
      media.className = 'ovani-bb__swap-option-media';
      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const body = document.createElement('div');
      body.className = 'ovani-bb__swap-option-body';
      const title = document.createElement('p');
      title.className = 'ovani-bb__swap-option-title';
      title.textContent = product.title || product.handle || 'Pack';
      const meta = document.createElement('p');
      meta.className = 'ovani-bb__swap-option-meta';
      const bits = [];
      if (product.price != null) bits.push(money(product.price, product.currency));
      if (product.reason) bits.push(product.reason);
      meta.textContent = bits.join(' · ');
      body.appendChild(title);
      body.appendChild(meta);

      const cta = document.createElement('span');
      cta.className = 'ovani-bb__swap-option-cta';
      cta.textContent = 'Use this';

      btn.appendChild(media);
      btn.appendChild(body);
      btn.appendChild(cta);
      return btn;
    }

    function fillSwapList(container, products) {
      if (!container) return;
      container.innerHTML = '';
      products.forEach((product) => container.appendChild(buildSwapOption(product)));
    }

    function trackEvent(payload) {
      if (!workerUrl || !requestId || !payload || !payload.event) return;
      const body = Object.assign({ request_id: requestId }, payload);
      try {
        fetch(`${workerUrl}/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(body),
          keepalive: true,
        }).catch(function () {
          /* best-effort logging */
        });
      } catch {
        /* best-effort logging */
      }
    }

    function closeSwapPanel() {
      swapTarget = null;
      searchRequestId += 1;
      altsRequestId += 1;
      if (searchTimer) {
        clearTimeout(searchTimer);
        searchTimer = null;
      }
      if (swapPanel) swapPanel.hidden = true;
      if (searchInput) searchInput.value = '';
      if (leftoversList) leftoversList.innerHTML = '';
      if (altsList) altsList.innerHTML = '';
      if (searchResults) searchResults.innerHTML = '';
      if (leftoversSection) leftoversSection.hidden = true;
      setStatus(altsStatus, '', null);
      setStatus(searchStatus, '', null);
      document.body.style.overflow = '';
    }

    function applySwap(replacement) {
      if (!swapTarget || !replacement || !replacement.handle) return;
      const bundle = activeBundle();
      if (!bundle || !Array.isArray(bundle.products)) return;

      const inBundle = currentBundleHandles();
      if (inBundle.has(replacement.handle) && replacement.handle !== swapTarget.handle) {
        setStatus(status, 'That pack is already in your bundle.', 'error');
        return;
      }

      const index = bundle.products.findIndex((p) => p.handle === swapTarget.handle);
      if (index < 0) {
        closeSwapPanel();
        return;
      }

      const fromTitle = swapTarget.title || swapTarget.handle;
      const toTitle = replacement.title || replacement.handle;
      const fromHandle = swapTarget.handle || '';
      const toHandle = replacement.handle || '';

      // Keep discount_code / discount_label untouched — only replace the product slot.
      bundle.products[index] = replacement;
      closeSwapPanel();
      renderActiveBundle();
      persistDraft();
      trackEvent({
        event: 'swap',
        from_title: fromTitle,
        to_title: toTitle,
        from_handle: fromHandle,
        to_handle: toHandle,
      });
      setStatus(
        status,
        `Swapped in ${replacement.title || replacement.handle}. Your code stays the same.`,
        'ok'
      );
    }

    async function loadAlternatives() {
      if (!workerUrl || !swapTarget || !altsList) return;
      const requestId = ++altsRequestId;
      setStatus(
        altsStatus,
        '',
        null
      );
      if (altsStatus) {
        altsStatus.innerHTML =
          '<span class="ovani-bb__loading"><span class="ovani-bb__spinner" aria-hidden="true"></span> Finding ideas…</span>';
      }
      altsList.innerHTML = '';

      try {
        const response = await fetch(`${workerUrl}/alternatives`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            description: lastDescription,
            categories: lastCategories.length ? lastCategories : selectedCategories(),
            replace_handle: swapTarget.handle,
            exclude_handles: excludeHandlesForApi(),
            owned_titles: ownedTitlesForApi(),
            limit: 6,
          }),
          signal: AbortSignal.timeout(60000),
        });
        const data = await response.json();
        if (requestId !== altsRequestId) return;
        if (!response.ok) {
          throw new Error(
            errorFromWorkerResponse(response, data, 'Could not load suggestions.')
          );
        }
        const products = Array.isArray(data.products) ? data.products : [];
        const inBundle = currentBundleHandles();
        const filtered = filterOutOwnedProducts(products).filter(
          (p) => p.handle && !inBundle.has(p.handle) && p.handle !== swapTarget.handle
        );
        fillSwapList(altsList, filtered);
        if (!filtered.length) {
          setStatus(altsStatus, 'No extra ideas right now — try search below.', null);
        } else {
          setStatus(altsStatus, '', null);
        }
      } catch (err) {
        if (requestId !== altsRequestId) return;
        altsList.innerHTML = '';
        const timedOut =
          err &&
          (err.name === 'TimeoutError' ||
            err.name === 'AbortError' ||
            /timed?\s*out/i.test(String(err.message || '')));
        setStatus(
          altsStatus,
          timedOut
            ? 'Ideas are taking too long — use search below, or try again.'
            : err.message || 'Could not load suggestions. You can still search below.',
          'error'
        );
      }
    }

    async function runSearch(query) {
      if (!workerUrl || !searchResults) return;
      const trimmed = String(query || '').trim();
      const requestId = ++searchRequestId;

      if (trimmed.length < 2) {
        searchResults.innerHTML = '';
        setStatus(
          searchStatus,
          trimmed.length ? 'Type at least 2 characters.' : '',
          null
        );
        return;
      }

      setStatus(searchStatus, '', null);
      if (searchStatus) {
        searchStatus.innerHTML =
          '<span class="ovani-bb__loading"><span class="ovani-bb__spinner" aria-hidden="true"></span> Searching…</span>';
      }

      try {
        const response = await fetch(`${workerUrl}/search`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            query: trimmed,
            categories: lastCategories.length ? lastCategories : selectedCategories(),
            exclude_handles: Array.from(currentBundleHandles()),
            owned_titles: ownedTitlesForApi(),
            limit: 12,
          }),
          signal: AbortSignal.timeout(60000),
        });
        const data = await response.json();
        if (requestId !== searchRequestId) return;
        if (!response.ok) {
          throw new Error(errorFromWorkerResponse(response, data, 'Search failed.'));
        }
        const products = Array.isArray(data.products) ? data.products : [];
        const inBundle = currentBundleHandles();
        const filtered = filterOutOwnedProducts(products).filter(
          (p) => p.handle && !inBundle.has(p.handle) && (!swapTarget || p.handle !== swapTarget.handle)
        );
        fillSwapList(searchResults, filtered);
        if (!filtered.length) {
          setStatus(searchStatus, 'No matching packs. Try another keyword.', null);
        } else {
          setStatus(searchStatus, '', null);
        }
      } catch (err) {
        if (requestId !== searchRequestId) return;
        searchResults.innerHTML = '';
        const timedOut =
          err &&
          (err.name === 'TimeoutError' ||
            err.name === 'AbortError' ||
            /timed?\s*out/i.test(String(err.message || '')));
        setStatus(
          searchStatus,
          timedOut
            ? 'Search is taking too long — try a shorter keyword, or try again.'
            : err.message || 'Search failed.',
          'error'
        );
      }
    }

    function openSwapPanel(product) {
      if (!swapPanel || !product || !product.handle) return;
      closePreview();
      swapTarget = product;

      if (swapReplacing) {
        swapReplacing.textContent = `Replacing: ${product.title || product.handle}`;
      }

      const leftovers = leftoverProducts();
      if (leftoversSection && leftoversList) {
        if (leftovers.length) {
          leftoversSection.hidden = false;
          fillSwapList(leftoversList, leftovers);
        } else {
          leftoversSection.hidden = true;
          leftoversList.innerHTML = '';
        }
      }

      if (searchInput) searchInput.value = '';
      if (searchResults) searchResults.innerHTML = '';
      setStatus(searchStatus, '', null);
      if (altsList) altsList.innerHTML = '';

      swapPanel.hidden = false;
      document.body.style.overflow = 'hidden';
      loadAlternatives();
      if (searchInput) {
        requestAnimationFrame(() => searchInput.focus());
      }
    }

    function renderActiveBundle() {
      const bundle = activeBundle();
      if (!bundle) return;

      closePreview();
      if (rowDropdown.parentNode) rowDropdown.remove();

      grid.innerHTML = '';
      bundle.products.forEach((product, index) => grid.appendChild(buildCard(product, index)));

      if (codeEl) {
        const code = String(bundle.discount_code || '').trim();
        if (codeLabelEl) codeLabelEl.hidden = !code;
        if (codeValueEl) {
          codeValueEl.textContent = code;
          codeValueEl.hidden = !code;
        }
        if (codeNoteEl) {
          codeNoteEl.textContent = formatCodeNote(
            code,
            bundleDiscountLabel(bundle, selectedSize),
            selectedSize,
            bundle.discount_code_error
          );
        }
        codeEl.hidden = false;
      }

      if (savingsEl) {
        const savings = bundleSavings(bundle.products, discountPercentForSize(root, selectedSize));
        if (savings) {
          savingsEl.innerHTML =
            `<s class="ovani-bb__savings-full">${escapeHtml(money(savings.full, savings.currency))}</s>` +
            `<span class="ovani-bb__savings-price">${escapeHtml(money(savings.discounted, savings.currency))}</span>` +
            `<span class="ovani-bb__savings-saved">You save ${escapeHtml(money(savings.saved, savings.currency))}</span>`;
          savingsEl.hidden = false;
        } else {
          savingsEl.innerHTML = '';
          savingsEl.hidden = true;
        }
      }

      const summary = bundleSoundTotal(bundle.products);
      if (summaryEl) {
        summaryEl.hidden = !summary;
      }
      if (summary) {
        root.querySelectorAll('[data-ovani-bb-summary-total]').forEach((el) => {
          el.textContent = summary;
        });
      }

      if (resultsSubtitleEl) {
        resultsSubtitleEl.textContent = 'Tailored to your game.';
        resultsSubtitleEl.hidden = false;
      }

      results.hidden = false;
      if (addBtn) addBtn.disabled = bundle.products.length === 0;
      applyPromoUi();
    }

    function persistDraft() {
      if (!bundlesBySize) return;
      writeSavedBundleDraft(draftStorageKey, {
        v: DRAFT_STORAGE_VERSION,
        description: lastDescription || textarea.value.trim(),
        categories: lastCategories.length ? lastCategories.slice() : selectedCategories(),
        selectedSize: selectedSize,
        bundlesBySize: bundlesBySize,
        rankedProducts: rankedProducts,
        requestId: requestId,
        builtDescription: builtDescription,
        builtCategories: builtCategories,
      });
    }

    function snapshotDraftState() {
      if (!bundlesBySize) return null;
      return {
        bundlesBySize: bundlesBySize,
        rankedProducts: rankedProducts,
        lastDescription: lastDescription,
        lastCategories: lastCategories.slice(),
        requestId: requestId,
        builtDescription: builtDescription,
        builtCategories: builtCategories,
        selectedSize: selectedSize,
      };
    }

    function applyDraftState(snap) {
      if (!snap || !snap.bundlesBySize) return false;
      var nextBundles = {};
      var hasBundle = false;
      currentBundleSizes(root).forEach(function (size) {
        var entry = bundleEntry(snap.bundlesBySize, size);
        if (entry && Array.isArray(entry.products) && entry.products.length) {
          nextBundles[size] = entry;
          hasBundle = true;
        }
      });
      if (!hasBundle) return false;

      bundlesBySize = nextBundles;
      rankedProducts = Array.isArray(snap.rankedProducts) ? snap.rankedProducts : [];
      lastDescription = String(snap.lastDescription || snap.description || '').trim();
      lastCategories = Array.isArray(snap.lastCategories || snap.categories)
        ? (snap.lastCategories || snap.categories).slice()
        : [];
      requestId = snap.requestId ? String(snap.requestId) : null;
      builtDescription =
        snap.builtDescription != null ? snap.builtDescription : lastDescription || null;
      builtCategories = Array.isArray(snap.builtCategories)
        ? snap.builtCategories.slice()
        : lastCategories.slice();

      var nextSize = Number(snap.selectedSize);
      if (currentBundleSizes(root).includes(nextSize) && nextBundles[nextSize]) {
        selectedSize = nextSize;
      } else {
        selectedSize = currentBundleSizes(root).find(function (size) {
          return nextBundles[size];
        }) || 6;
      }
      return true;
    }

    function resetBuilderToEmpty() {
      bundlesBySize = null;
      rankedProducts = [];
      lastDescription = '';
      lastCategories = [];
      requestId = null;
      builtDescription = null;
      builtCategories = null;
      textarea.value = '';
      categoryInputs.forEach(function (input) {
        input.checked = true;
      });
      selectedSize = 6;
      setSizePressed(selectedSize);
      if (sizePicker) sizePicker.hidden = true;
      if (results) results.hidden = true;
      grid.innerHTML = '';
      if (codeEl) {
        codeEl.hidden = true;
        if (codeValueEl) codeValueEl.textContent = '';
        if (codeNoteEl) codeNoteEl.textContent = '';
      }
      if (savingsEl) {
        savingsEl.innerHTML = '';
        savingsEl.hidden = true;
      }
      if (summaryEl) summaryEl.hidden = true;
      if (addBtn) addBtn.disabled = true;
      closeSwapPanel();
      closePreview();
      setStatus(status, '', null);
      updateRebuildControl();
    }

    function discardSavedDraft() {
      clearSavedBundleDraft(draftStorageKey);
      resetBuilderToEmpty();
    }

    function restoreFormFromDraft(draft) {
      textarea.value = String(draft.description || '').slice(0, 2000);
      var cats = Array.isArray(draft.categories) ? draft.categories : [];
      if (cats.length) {
        var allowed = new Set(
          cats.map(function (item) {
            return String(item).trim().toLowerCase();
          })
        );
        categoryInputs.forEach(function (input) {
          input.checked = allowed.has(input.value);
        });
      }
    }

    function maybeRestoreSavedDraft() {
      if (incomingNewRequest) return;
      var draft = readSavedBundleDraft(draftStorageKey);
      if (!draft) return;
      if (!applyDraftState(draft)) {
        clearSavedBundleDraft(draftStorageKey);
        return;
      }
      if (bundleProductsFullyOwned(activeBundle())) {
        discardSavedDraft();
        return;
      }
      restoreFormFromDraft(draft);
      setSizePressed(selectedSize);
      if (sizePicker) sizePicker.hidden = false;
      renderActiveBundle();
      updateRebuildControl();
      setStatus(status, 'Welcome back — your bundle is still here.', 'ok');
      checkSavedDraftPurchased();
    }

    function checkSavedDraftPurchased() {
      if (!workerUrl || !bundlesBySize) return;
      var codes = discountCodesFromBundles(bundlesBySize);
      if (!codes.length) return;
      fetch(
        workerUrl + '/bundle-status?codes=' + encodeURIComponent(codes.join(',')),
        { headers: { Accept: 'application/json' } }
      )
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok && result.data && result.data.purchased) {
            discardSavedDraft();
          }
        })
        .catch(function () {});
    }

    function clearPreviewMedia() {
      if (rowMedia) rowMedia.innerHTML = '';
      if (mobileMedia) mobileMedia.innerHTML = '';
      if (rowDetails) rowDetails.innerHTML = '';
      if (mobileDetails) mobileDetails.innerHTML = '';
    }

    function setCardsExpanded(activeCard) {
      grid.querySelectorAll('.ovani-bb__card').forEach((card) => {
        const isOpen = card === activeCard;
        card.classList.toggle('is-open', isOpen);
        if (card.classList.contains('ovani-bb__card--expandable')) {
          card.setAttribute('aria-expanded', String(isOpen));
        }
      });
    }

    function closePreview() {
      openCard = null;
      setCardsExpanded(null);
      rowDropdown.hidden = true;
      rowDropdown.classList.remove('is-active');
      if (mobileDropdown) {
        mobileDropdown.hidden = true;
        mobileDropdown.classList.remove('is-active');
      }
      clearPreviewMedia();
    }

    function fillDetails(target, product) {
      if (!target) return;
      const url = escapeHtml(productPageUrl(product));
      target.innerHTML =
        `<h4 class="ovani-bb__dropdown-title">${escapeHtml(product.title || product.handle)}</h4>` +
        `<p class="ovani-bb__dropdown-price">${escapeHtml(money(product.price, product.currency))}</p>` +
        contentsStatsHtml(product) +
        `<a class="ovani-bb__dropdown-product-link" href="${url}" target="_blank" rel="noopener">View full product</a>`;
    }

    function openPreview(card, options) {
      const scroll = !options || options.scroll !== false;
      const product = card._ovaniProduct;
      if (!product || !hasPreview(product)) return;

      if (openCard === card && !rowDropdown.hidden && !isMobilePreview()) {
        closePreview();
        return;
      }
      if (openCard === card && mobileDropdown && !mobileDropdown.hidden && isMobilePreview()) {
        closePreview();
        return;
      }

      openCard = card;
      setCardsExpanded(card);
      clearPreviewMedia();

      const mediaHtml = previewMediaHtml(product);

      if (isMobilePreview()) {
        rowDropdown.hidden = true;
        rowDropdown.classList.remove('is-active');
        if (mobileMedia) mobileMedia.innerHTML = mediaHtml;
        fillDetails(mobileDetails, product);
        if (mobileDropdown) {
          mobileDropdown.hidden = false;
          mobileDropdown.classList.add('is-active');
        }
        return;
      }

      if (mobileDropdown) {
        mobileDropdown.hidden = true;
        mobileDropdown.classList.remove('is-active');
      }

      const cards = Array.from(grid.querySelectorAll('.ovani-bb__card'));
      const index = cards.indexOf(card);
      if (index < 0) return;

      const cols = getColumnCount();
      const rowEnd = Math.min(cards.length - 1, (Math.floor(index / cols) + 1) * cols - 1);
      const after = cards[rowEnd];
      if (after && after.nextSibling !== rowDropdown) {
        after.after(rowDropdown);
      }

      if (rowMedia) rowMedia.innerHTML = mediaHtml;
      fillDetails(rowDetails, product);
      rowDropdown.hidden = false;
      rowDropdown.classList.add('is-active');
      if (scroll) scrollPreviewIntoView(rowDropdown);
    }

    function onCardActivate(card) {
      if (!card.classList.contains('ovani-bb__card--expandable')) return;
      openPreview(card);
    }

    grid.addEventListener('click', (event) => {
      const swapBtn = event.target.closest('[data-ovani-bb-swap]');
      if (swapBtn && grid.contains(swapBtn)) {
        event.preventDefault();
        event.stopPropagation();
        const card = swapBtn.closest('.ovani-bb__card');
        if (card && card._ovaniProduct) openSwapPanel(card._ovaniProduct);
        return;
      }

      const card = event.target.closest('.ovani-bb__card');
      if (!card || !grid.contains(card)) return;
      onCardActivate(card);
    });

    grid.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('[data-ovani-bb-swap]')) return;
      const card = event.target.closest('.ovani-bb__card');
      if (!card || !grid.contains(card) || event.target.closest('a')) return;
      event.preventDefault();
      onCardActivate(card);
    });

    if (rowClose) {
      rowClose.addEventListener('click', (event) => {
        event.stopPropagation();
        closePreview();
      });
    }

    if (mobileClose) {
      mobileClose.addEventListener('click', (event) => {
        event.stopPropagation();
        closePreview();
      });
    }

    if (mobileDropdown) {
      mobileDropdown.addEventListener('click', (event) => {
        if (event.target === mobileDropdown) closePreview();
      });
    }

    if (swapClose) {
      swapClose.addEventListener('click', (event) => {
        event.stopPropagation();
        closeSwapPanel();
      });
    }

    if (swapPanel) {
      swapPanel.addEventListener('click', (event) => {
        if (event.target === swapPanel) {
          closeSwapPanel();
          return;
        }
        const pick = event.target.closest('[data-ovani-bb-swap-pick]');
        if (!pick || !swapPanel.contains(pick)) return;
        event.preventDefault();
        applySwap(pick._ovaniProduct);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        if (searchTimer) clearTimeout(searchTimer);
        const value = searchInput.value;
        searchTimer = setTimeout(() => {
          runSearch(value);
        }, 250);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (swapPanel && !swapPanel.hidden) {
        closeSwapPanel();
        return;
      }
      closePreview();
    });

    window.addEventListener('resize', () => {
      if (!openCard) return;
      const card = openCard;
      closePreview();
      openPreview(card, { scroll: false });
    });

    sizeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        const nextSize = Number(btn.dataset.ovaniBbSize);
        if (!currentBundleSizes(root).includes(nextSize)) return;
        if (bundlesBySize && !bundleEntry(bundlesBySize, nextSize)) return;
        selectedSize = nextSize;
        setSizePressed(selectedSize);
        closeSwapPanel();
        if (bundlesBySize) {
          renderActiveBundle();
          persistDraft();
        }
      });
    });

    textarea.addEventListener('input', updateRebuildControl);
    categoryInputs.forEach((input) => {
      input.addEventListener('change', updateRebuildControl);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!workerUrl) {
        setStatus(status, 'Bundle Builder is not configured yet (missing Worker URL).', 'error');
        return;
      }

      const categories = selectedCategories();
      if (!categories.length) {
        setStatus(status, 'Pick at least one type: music, sound effects, or voice acting.', 'error');
        return;
      }

      const description = textarea.value.trim();
      if (description.length < 8) {
        setStatus(status, 'Tell us a bit more about your game (at least a sentence).', 'error');
        return;
      }
      if (builtDescription !== null && buildInputsUnchanged()) {
        return;
      }

      const previousDraft = snapshotDraftState();

      submit.disabled = true;
      if (addBtn) addBtn.disabled = true;
      setSizeButtonsBusy(true);
      bundlesBySize = null;
      rankedProducts = [];
      lastDescription = '';
      lastCategories = [];
      requestId = null;
      closeSwapPanel();
      closePreview();
      if (rowDropdown.parentNode) rowDropdown.remove();
      setStatus(status, '', null);
      var loadingHtml =
        '<span class="ovani-bb__loading"><span class="ovani-bb__spinner" aria-hidden="true"></span><span class="ovani-bb__loading-copy"><span>Building your custom bundle…</span><span class="ovani-bb__loading-hint">This can take up to 2 minutes.</span></span></span>';
      status.innerHTML = loadingHtml;

      try {
        await waitForOwnershipSync();

        const previewAt = previewPhase() ? previewAtForPhase(root, previewPhase()) : null;
        const vipCode = isDefoldJamProfile(root) ? '' : savedVipCode();
        const recommendBody = JSON.stringify({
          description,
          categories,
          initial_size: selectedSize,
          // Only a local preview worker reads this; the live worker ignores it.
          ...(previewAt ? { preview_at: previewAt } : {}),
          ...(vipCode ? { vip: vipCode } : {}),
          owned_titles: ownedTitlesForApi(),
          ...(customerEmail ? { customer_email: customerEmail } : {}),
          page_url: String(window.location.href || '').split('#')[0],
          ...(customAudioDraftId ? { draft_id: customAudioDraftId } : {}),
          // DEFOLD GAME JAM 2026 — omit on the public page so Worker mints 25/35/45 codes.
          ...(discountProfile === DEFOLD_DISCOUNT_PROFILE
            ? { discount_profile: DEFOLD_DISCOUNT_PROFILE }
            : {}),
        });

        let data = null;
        while (true) {
          const response = await fetch(`${workerUrl}/recommend`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: recommendBody,
          });
          let payload = {};
          try {
            payload = await response.json();
          } catch {
            payload = {};
          }
          if (response.status === 429) {
            setStatus(status, BUSY_WAIT_MESSAGE, 'warn');
            await sleep(BUSY_RETRY_MS);
            setStatus(status, '', null);
            status.innerHTML = loadingHtml;
            continue;
          }
          if (!response.ok) {
            throw new Error(
              errorFromWorkerResponse(
                response,
                payload,
                'Something went wrong building your bundle.'
              )
            );
          }
          data = payload;
          break;
        }

        if (vipCode) rememberVipResult(vipCode, data.vip === true);
        bundlesBySize = parseBundlesResponse(data);
        if (!bundlesBySize) {
          throw new Error('Something went wrong building your bundle.');
        }

        requestId = data.request_id ? String(data.request_id) : null;
        lastDescription = description;
        lastCategories = categories.slice();
        builtDescription = description;
        builtCategories = categories.slice();
        if (customAudioDraftId) {
          try {
            sessionStorage.removeItem(DRAFT_KEY);
          } catch (err) {}
        }
        const fullBundle =
          bundlesBySize[20] || bundlesBySize[10];
        rankedProducts =
          fullBundle && Array.isArray(fullBundle.products)
            ? fullBundle.products.map((p) => Object.assign({}, p))
            : [];

        const initialFromApi = Number(data.initial_size);
        if (currentBundleSizes(root).includes(initialFromApi) && bundlesBySize[initialFromApi]) {
          selectedSize = initialFromApi;
        } else if (!bundlesBySize[selectedSize]) {
          selectedSize = currentBundleSizes(root).find((size) => bundlesBySize[size]) || 6;
        }
        setSizePressed(selectedSize);
        if (sizePicker) sizePicker.hidden = false;
        renderActiveBundle();
        persistDraft();
        var built = activeBundle();
        if (!customerEmail) {
          trackKlaviyoEvent(
            'Built Bundle',
            bundleEventProperties(
              built && built.products,
              built && built.discount_code
            ),
            customerEmail
          );
        }
        if (data.notice) {
          setStatus(status, String(data.notice), 'info');
        } else {
          setStatus(status, '', null);
        }
        scrollResultsIntoView(results, grid);
      } catch (err) {
        if (previousDraft && applyDraftState(previousDraft)) {
          setSizePressed(selectedSize);
          if (sizePicker) sizePicker.hidden = false;
          renderActiveBundle();
        } else {
          bundlesBySize = null;
          rankedProducts = [];
          lastDescription = '';
          lastCategories = [];
          requestId = null;
        }
        setStatus(status, err.message || 'Could not build a bundle right now.', 'error');
      } finally {
        updateRebuildControl();
        setSizeButtonsBusy(false);
      }
    });

    function goToCart(discountCode) {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      if (discountCode) {
        window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartUrl)}`;
      } else {
        window.location.href = cartUrl;
      }
    }

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const bundle = activeBundle();
        if (!bundle || !bundle.products.length) return;
        const products = bundle.products;
        const discountCode = bundle.discount_code || null;
        const discountLabel = bundleDiscountLabel(bundle, selectedSize);

        addBtn.disabled = true;
        setStatus(status, 'Adding bundle to cart…', null);

        try {
          // Cart notification only supports a single line item; multi-item
          // bundles use the drawer (if present) or redirect to /cart.
          const cartDrawer = document.querySelector('cart-drawer');
          await addBundleToCart(products);

          let discountApplied = false;
          if (discountCode) {
            const discountState = await applyDiscountCode(discountCode);
            discountApplied = Boolean(discountState && discountState.applied);
          }

          trackEvent({
            event: 'add_to_cart',
            size: selectedSize,
            pack_titles: products.map(function (p) {
              return p.title || p.handle || '';
            }),
            discount_code: discountCode,
            description: lastDescription,
            categories: lastCategories,
            ...(customerEmail ? { customer_email: customerEmail } : {}),
            page_url: String(window.location.href || '').split('#')[0],
          });
          if (!customerEmail) {
            trackKlaviyoEvent(
              'Added Bundle to Cart',
              bundleEventProperties(products, discountCode),
              customerEmail
            );
          }

          let openedDrawer = false;
          if (cartDrawer && typeof cartDrawer.openFresh === 'function') {
            try {
              await cartDrawer.openFresh(addBtn);
              openedDrawer = true;
            } catch {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open(addBtn);
                openedDrawer = true;
              }
            }
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(addBtn);
            openedDrawer = true;
          }

          if (!openedDrawer) {
            goToCart(discountCode);
            return;
          }

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ovani-bundle-builder' });
          }

          if (discountCode && discountApplied) {
            setStatus(
              status,
              `Bundle added! Code ${discountCode} is applied for ${discountLabel || 'your discount'}.`,
              'ok'
            );
          } else if (discountCode) {
            setStatus(
              status,
              `Bundle added, but code ${discountCode} did not apply. Try it at checkout, or rebuild for a new code.`,
              'error'
            );
          } else {
            setStatus(
              status,
              'Bundle added! No personal code was available — you can still checkout at full price or rebuild for a code.',
              'ok'
            );
          }
        } catch (err) {
          setStatus(status, err.message || 'Could not add to cart.', 'error');
        } finally {
          addBtn.disabled = false;
        }
      });
    }

    maybeRestoreSavedDraft();
  }

  function boot() {
    document.querySelectorAll('[data-ovani-bundle-builder]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
